import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { finalize, ReplaySubject } from "rxjs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { Area } from "src/app/shared/model/tickets/area.model";
import { GestionclientesService } from "src/app/clientes/gestionclientes.service";
import { TicketsService } from "src/app/tickets/tickets.service";
import { ProyectosService } from "../proyectos.service";
import { ModalAgregarRiesgo } from "./modal-agregar-riesgo/modal-agregar-riesgo.component";
import { ConsultaRiesgosComponent } from "./consulta-riesgos/consulta-riesgos.component";

@Component({
  selector: "app-gestion-riesgo",
  standalone: true,
  templateUrl: "./gestion_riesgos.component.html",
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    ConsultaRiesgosComponent,
  ],
})
export class GestionRiesgosComponent implements OnInit {
  selectArea: Area | null = null;
  formArea = new FormControl("");
  filterArea = new ReplaySubject<Area[]>(1);
  consultaArea = new ConsultaList<Area>();
  listaAreas: Area[] = [];

  projects: Proyecto[] = [];
  nomProyecto = "";
  clientefl: number | null = null;
  formCliente = new FormControl("");
  listaClientes: Cliente[] = [];
  regPagCliente = 1000;
  requestFilter = new ConsultaList<Proyecto>();
  requestCliente = new ConsultaList<Cliente>();
  dialogRef: MatDialogRef<any>;

  totalRegistros = 0;
  currentPage = 1;
  pageSize = 5;
  readonly pageSizeOptions = [5, 10, 20];
  loading = false;

  proyectoSeleccionado: Proyecto | null = null;
  mostrarPrincipal = true;
  mostrarConsulta = false;

  constructor(
    private modalDialog: MatDialog,
    private proyectoService: ProyectosService,
    private clientService: GestionclientesService,
    private ticketService: TicketsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.formArea.valueChanges.subscribe(() => this.filtraAreas());
    this.formCliente.valueChanges.subscribe(() => this.filtraCliente());

    this.requestCliente.regInicial = 0;
    this.requestCliente.regXPagina = this.regPagCliente;

    this.consultaAreasActivos();
    this.consultarClientes();
    this.consultarProyectos();
  }

  consultarProyectos(page = 1): void {
    this.currentPage = Math.max(page, 1);
    this.loading = this.projects.length === 0;
    this.cdr.detectChanges();

    this.requestFilter.param1 = this.nomProyecto?.trim() ?? "";
    this.requestFilter.param4 = this.clientefl;
    this.requestFilter.param5 = this.selectArea?.id ?? null;
    this.requestFilter.regInicial = (this.currentPage - 1) * this.pageSize;
    this.requestFilter.regXPagina = this.pageSize;
    this.requestFilter.pagina = this.currentPage - 1;

    this.proyectoService
      .consultaProyectoMongo(this.requestFilter)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response: any) => {
          this.projects = Array.isArray(response?.content) ? [...response.content] : [];
          this.totalRegistros = this.resolveTotalRegistros(response, this.projects.length);

          const maxPages = this.totalPages;
          if (maxPages > 0 && this.currentPage > maxPages) {
            this.consultarProyectos(maxPages);
            return;
          }

          this.cdr.detectChanges();
        },
        error: () => {
          this.projects = [];
          this.totalRegistros = 0;
          this.cdr.detectChanges();
        },
      });
  }

  openModRiesgo(proyecto: Proyecto): void {
    this.dialogRef = this.modalDialog.open(ModalAgregarRiesgo, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      panelClass: "custom-modalbox",
      data: { idProyecto: proyecto.id },
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  openConsultaRiesgo(proyecto: Proyecto): void {
    this.proyectoSeleccionado = proyecto;
    this.mostrarPrincipal = false;
    this.mostrarConsulta = true;
  }

  clearNombrePro(): void {
    this.nomProyecto = "";
    this.consultarProyectos(1);
  }

  clearNombreCli(): void {
    this.clientefl = null;
    this.formCliente.setValue("");
    this.consultarProyectos(1);
  }

  clearArea(): void {
    this.formArea.setValue("");
    this.selectArea = null;
    this.requestFilter.param5 = null;
    this.consultaAreasActivos();
    this.consultarProyectos(1);
  }

  consultarClientes(): void {
    this.clientService.filtroBusquedaCliente(this.requestCliente).subscribe((res) => {
      this.listaClientes = Array.isArray(res?.list) ? res.list : [];
    });
  }

  filtraCliente(): void {
    const searchValue = (this.formCliente.value ?? "").toString().trim().toLowerCase();
    this.requestCliente.param1 = searchValue;

    this.clientService.filtroBusquedaCliente(this.requestCliente).subscribe((res) => {
      this.listaClientes = Array.isArray(res?.list) ? res.list : [];
    });
  }

  getArea(valor: Area | null): void {
    this.selectArea = valor;
    this.requestFilter.param5 = valor?.id ?? null;
    this.consultarProyectos(1);
  }

  consultaAreasActivos(): void {
    this.consultaArea.regInicial = 0;
    this.consultaArea.regFinal = 10000;

    this.ticketService.consultarAreaPaginacion(this.consultaArea).subscribe((res) => {
      if (res?.list?.length) {
        this.listaAreas = res.list;
        this.filterArea.next(this.listaAreas.slice());
      } else {
        this.listaAreas = [];
        this.filterArea.next([]);
      }
    });
  }

  filtraAreas(): void {
    const searchValue = (this.formArea.value ?? "").toString().trim().toLowerCase();

    if (!searchValue) {
      this.filterArea.next(this.listaAreas.slice());
      return;
    }

    this.filterArea.next(
      this.listaAreas.filter((area) => area.area?.toLowerCase().includes(searchValue)),
    );
  }

  mostrarVistaPrincipal(vista: boolean): void {
    if (vista) {
      this.mostrarPrincipal = true;
      this.mostrarConsulta = false;
      this.proyectoSeleccionado = null;
      this.consultarProyectos(this.currentPage);
    }
  }

  mostrarMascaraConsulta(_mostrar: boolean): void {
    this.cdr.detectChanges();
  }

  onPageSizeChange(value: number): void {
    this.pageSize = Number(value);
    this.consultarProyectos(1);
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }
    this.consultarProyectos(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get totalPages(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
  }

  get showPagination(): boolean {
    return this.totalRegistros > 0;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRegistros);
  }

  getProjectIdentifier(proyecto: Proyecto): string {
    return proyecto?.idProyecto || proyecto?.id?.toString() || "-";
  }

  getProjectShortName(proyecto: Proyecto): string {
    return proyecto?.nombre_corto || "Sin nombre corto";
  }

  getDateRangeLabel(proyecto: Proyecto): string {
    const start = this.formatDate(proyecto?.fechaInicio);
    const end = this.formatDate(proyecto?.fechaFin);

    if (!start && !end) {
      return "Sin fechas definidas";
    }

    if (!start || !end) {
      return `${start || "Sin inicio"} / ${end || "Sin fin"}`;
    }

    return `${start} / ${end}`;
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);

    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === "number";
  }

  formatDate(date: Date | string | null | undefined): string {
    if (!date) {
      return "";
    }

    const parsedDate = typeof date === "string" ? new Date(date) : date;
    if (!(parsedDate instanceof Date) || Number.isNaN(parsedDate.getTime())) {
      return "";
    }

    return parsedDate.toLocaleDateString();
  }

  private resolveTotalRegistros(response: any, currentItems: number): number {
    const candidates = [
      response?.totalElements,
      response?.pTotalItems,
      response?.totalItems,
      response?.totalRegistros,
    ];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed >= 0) {
        return parsed;
      }
    }

    if (currentItems === 0) {
      return 0;
    }

    return (this.currentPage - 1) * this.pageSize + currentItems;
  }
}
